import { ChangeDetectionStrategy, Component, computed, input, viewChildren } from '@angular/core';
import { ProductGallery } from '../../models/product-gallery.model';
import { EmblaSliderComponent } from '@teamfoster/embla-slider';
import { MediaComponent } from 'src/app/core/components/media/media.component';
import { MediaPointMapComponent } from 'src/app/core/components/media-point-map/media-point-map.component';

@Component({
  selector: 'app-product-gallery',
  imports: [EmblaSliderComponent, MediaComponent, MediaPointMapComponent],
  templateUrl: './product-gallery.component.html',
  styleUrl: './product-gallery.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductGalleryComponent {
  productGallery = input.required<ProductGallery>();
  pointMaps = viewChildren(MediaPointMapComponent);

  pointMapOrientations = computed(() => {
    return this.productGallery().imageMaps.map(imageMap => {
      const orientation = (imageMap.media?.width || 0) >= (imageMap.media?.height || 0) ? 2 : 1;
      return orientation;
    });
  });

  orientationScale = computed(() => this.pointMapOrientations().reduce((acc, orientation) => acc + orientation, 0));

  onMediaEnter(activePointMap: MediaPointMapComponent) {
    for (const pointMap of this.pointMaps()) {
      if (pointMap !== activePointMap) {
        pointMap.closeOverlay();
      }
    }
  }

  onMouseLeave(event: MouseEvent, pointMap: MediaPointMapComponent) {
    if (this.isOverlayTarget(event.relatedTarget)) {
      return;
    }

    pointMap?.closeOverlay();
  }

  onMediaClick(event: MouseEvent, pointMap: MediaPointMapComponent) {
    if (this.isOverlayTarget(event.target)) {
      return;
    }

    pointMap?.closeOverlay();
  }

  private isOverlayTarget(target: EventTarget | null) {
    return target instanceof Element && !!target.closest('.media-point-map-overlay');
  }

  onSliderTranslate() {
    for (const pointMap of this.pointMaps()) {
      pointMap.closeOverlay();
    }
  }
}
